
import { NoseurObject } from "@rivtn/noseur";
import en_US from "./en.json";

export interface Section {
    desc: string;
    icon: string;
    name: string;
    location: string;
}

export type JanusLabels = {
    logo: string;
    name: string;
    lang: string;
    rivtn: string;
    timezone: string;
    short_lang: string;
    short_name: string;
    display_name: string;
    landing: {
        desc: string;
        login: string;
        header: string;
        learn_more: string;
    };
    authenticate: {
        redirecting: string;
    };
    dashboard: {
        go: string;
        all: string;
        search: string;
        logout: string;
        link_copied: string;
    };
    sections: NoseurObject<Section[]>;
};

export type LanguageMap = { [key: string]: JanusLabels };

const languages: LanguageMap = {
    en_US,
};

let i18nData: JanusLabels;
let defaultLanguage: string;

export const i18nManager = {

    Labels: i18nData!,
    LabeslLoaded: false,
    ActiveLanguage: defaultLanguage!,

    switchLanguage(lang: string) {
        localStorage.setItem("rivtn.language", lang);
        window.location.reload();
    }

};

if (!i18nManager.LabeslLoaded) {
    //localStorage.setItem("rivtn.language", "es") // uncomment to test spanish
    //localStorage.setItem("rivtn.language", "en") // uncomment to test english

    defaultLanguage = navigator.language;
    if (localStorage.getItem("rivtn.language") !== null && localStorage.getItem("rivtn.language") !== "") {
        defaultLanguage = localStorage.getItem("rivtn.language") || "en";
    }
    i18nData = languages[defaultLanguage.replace('-', '_')] || languages["en_US"];
    i18nData.timezone = defaultLanguage;
    i18nManager.Labels = i18nData;
    i18nManager.LabeslLoaded = true;
    i18nManager.ActiveLanguage = defaultLanguage;
}